import React from 'react'
import ReactMarkdown, { Options } from 'react-markdown'

export const Markdown: React.FC<Options> = (props) => {
  return <ReactMarkdown
    {...props}
    components={{
      a({ children, ...props }) {
        const url = new URL(props.href ?? "", location.href)
        if (url.origin !== location.origin) {
          props.target = "_blank"
          props.rel = "noopener noreferrer"
        }
  
        return <a {...props}>{children}</a>
      },
    }}
  />
}

export default Markdown
